/**
 * Enum for roles.
 * @readonly
 * @enum {{role: string}}
 */
export const Roles = Object.freeze({
  AML_DESK: { role: 'AML_DESK' },
  APPROVATORE_MONITORAGGIO: { role: 'APPROVATORE_MONITORAGGIO' },
  APPROVA_PRATICA_FIELD_ANALYST: { role: 'APPROVA_PRATICA_FIELD_ANALYST' },
  APPROVA_PRATICA_UTENTE_BASE: { role: 'APPROVA_PRATICA_UTENTE_BASE' },
  FIELD_ANALYST: { role: 'FIELD_ANALYST' },
  MONITORAGGIO: { role: 'MONITORAGGIO' },
  RICHIESTA_MONITORAGGIO: { role: 'RICHIESTA_MONITORAGGIO' },
  RICHIESTA_ON_BOARDING: { role: 'RICHIESTA_ON_BOARDING' },
  SUPPORTO_AML_DESK: { role: 'SUPPORTO_AML_DESK' },
  SUPPORTO_FUNZIONE_AML: { role: 'SUPPORTO_FUNZIONE_AML' },
  TUTTI: { role: 'TUTTI' },
  UTENTE_BASE: { role: 'UTENTE_BASE' },
  UTENTE_INTERNO: { role: 'UTENTE_INTERNO' },
})
